import { cn } from '@/lib/utils';

const Input = ({
  label,
  name,
  type = 'text',
  className,
  value,
  error,
  required,
  placeholder,
  ...props
}) => {
  return (
    <div className="mb-6 w-full">
    {label && (
      <label 
        className="block text-[#FFFFFF] text-[16px] mb-2"
        htmlFor={name}
      >
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
    )}
    <input
      placeholder={placeholder}
      name={name}
      id={name}
      type={type}
      value={value}
      {...props}
      className={cn(
        'w-full bg-transparent border border-[#D2D2D585] rounded-md',
        'px-4 py-3 text-muted placeholder:text-gray-500',
        'focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500',
        error && 'border-red-500',
        className
      )}
    />
    {error && (
      <p className="mt-2 text-sm text-red-500">{error}</p>
    )}
  </div>
  );
};

export default Input;
